import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {Input} from '@common-web/components/ui/input';
import {CopyFromSection125} from '../components/CopyFromSection125';

export function MecAgent({
  disableFormCopy,
  showPepm = false,
}: {
  disableFormCopy?: boolean;
  showPepm?: boolean;
}) {
  const {control, getValues, setValue} = useFormContext();
  const copyFromSection125 = () => {
    const src = getValues('section125Form.agentOfRecord');
    if (src) {
      setValue('mecForm.agentOfRecord', src, {shouldDirty: true, shouldValidate: true});
    }
  };

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <div className='md:col-span-2'>
        {!disableFormCopy && <CopyFromSection125 onCopy={copyFromSection125} />}
      </div>
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.firstName'}
        render={({field}) => (
          <FormItem>
            <FormLabel>First Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.lastName'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Last Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.phone'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Phone</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.email'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input type='email' {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.additionalPhone'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Additional Phone (Optional)</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={'mecForm.agentOfRecord.additionalEmail'}
        render={({field}) => (
          <FormItem>
            <FormLabel>Additional Email (Optional)</FormLabel>
            <FormControl>
              <Input type='email' {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {showPepm && (
        <FormField
          control={control}
          name={'mecForm.agentOfRecord.pepm'}
          render={({field}) => (
            <FormItem>
              <FormLabel>PEPM</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}
